import React from 'react'
import { Pressable, StyleSheet, Text, View } from 'react-native'
import { DS } from '@/design-system'
import { translate } from '../../../i18n'

const REBUY_COUNT_OPTIONS = [1, 2, 3]

interface RebuyCountPickerProps {
  value: number | null
  onChange: (count: number | null) => void
}

export function RebuyCountPicker({ value, onChange }: RebuyCountPickerProps) {
  return (
    <View style={styles.container}>
      <Pressable onPress={() => onChange(null)} style={[styles.pill, value === null && styles.pillSelected]}>
        <Text style={[styles.label, value === null && styles.labelSelected]}>{translate('createGameV2.none')}</Text>
      </Pressable>
      {REBUY_COUNT_OPTIONS.map((count) => {
        const selected = count === value
        return (
          <Pressable key={count} onPress={() => onChange(count)} style={[styles.pill, selected && styles.pillSelected]}>
            <Text style={[styles.label, selected && styles.labelSelected]}>{count}</Text>
          </Pressable>
        )
      })}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 8
  },
  pill: {
    flex: 1,
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 50,
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey'],
    alignItems: 'center'
  },
  pillSelected: {
    backgroundColor: DS.palette['Global/Black']
  },
  label: {
    fontSize: 14,
    color: DS.palette['Global/Black']
  },
  labelSelected: {
    color: DS.palette['Global/White']
  }
})
